import { researchNodeById, type ResearchTree } from "@zend/content";
import type { ResearchNodeView } from "../api.js";

export const RESEARCH_TREE_ART: Record<ResearchTree, string> = {
  economy: "bld.hydro_farm", military: "unit.shieldwall_mk2", development: "bld.data_lab", defense: "bld.bastion_wall",
};

/** Subject imagery: the building or machine actually affected, not a random reward. */
export function researchArt(node: ResearchNodeView): string {
  const key = node.effect.key;
  const exact: Record<string, string> = {
    "production.RAT": "bld.hydro_farm", "production.POL": "bld.polymer_plant", "production.ALY": "bld.alloy_foundry",
    "production.ENC": "bld.fusion_reactor", "production.SCR": "bld.residential_block",
    "storage.capacity": "bld.storage_vault", "storage.protected": "bld.storage_vault",
    "build.speed": "bld.command_nexus", "research.speed": "bld.data_lab", "repair.speed": "bld.repair_bay",
    "fabrication.discount": "bld.workshop", "wall.hp": "bld.bastion_wall",
    "unit.chassis.tank": "unit.shieldwall_mk2", "unit.chassis.mecha": "unit.striker_beta", "unit.chassis.tripod": "unit.overwatch_nyx",
  };
  if (exact[key]) return exact[key];
  if (key.startsWith("unit.defender")) return "unit.shieldwall_mk2";
  if (key.startsWith("unit.attacker")) return "unit.rustbucket";
  if (key.startsWith("unit.support")) return "unit.toolbox";
  if (key.startsWith("turret.")) return "bld.turret_emplacement";
  if (key.startsWith("trap.")) return "bld.trap_workshop";
  if (key.startsWith("shield.")) return "bld.shield_generator";
  if (key === "warning.time" || key === "scout.resist") return "bld.sensor_array";
  if (key.startsWith("march.") || key === "gather.speed") return "bld.logistics_depot";
  if (key === "xp.gain") return "bld.training_simulator";
  return RESEARCH_TREE_ART[researchNodeById(node.nodeId).tree];
}

/** Match the consumers: slots/stamina are additive, warning is seconds, burn is a reduction. */
export function researchEffectValue(key: string, value: number): string {
  const sign = key === "burn.duration" && value > 0 ? "−" : value > 0 ? "+" : "";
  return `${sign}${value}${key === "march.slots" || key === "stamina.cap" ? "" : key === "warning.time" ? "s" : "%"}`;
}

export function researchRequirements(nodeId: string, nodes: ResearchNodeView[]) {
  return researchNodeById(nodeId).requires.map(id => ({ id, level: nodes.find(n => n.nodeId === id)?.level ?? 0 }));
}
